import React, {useMemo} from "react"
import {resizeCloudinaryImage} from "@irati/utils/images"

type Sizes = {
  width: number
  height?: number
}

type Props = {
  src: string
  imgSizes: Sizes[]
  mediaQueries: string[]
  alt: string
  width?: number | string
  height?: number | string
  loadingType?: "lazy" | "eager"
}

export const Image: React.FC<Props> = ({src, imgSizes, mediaQueries, width = "100%", height = "auto", loadingType = "lazy", alt}) => {
  const [srcSet, sizes] = useMemo(() => {
    const _srcSet = imgSizes
      .map((size) => {
        return `${resizeCloudinaryImage(src, size.width, size.height ?? size.width)} ${size.width}w`
      })
      .join(", ")
    const _sizes = mediaQueries.join(", ")
    return [_srcSet, _sizes]
  }, [])

  return <img src={src} srcSet={srcSet} sizes={sizes} width={width} height={height} loading={loadingType} alt={alt} />
}
